import { lazy } from "react";

const RELOAD_KEY = "chunk-reload-at";
const RELOAD_GUARD_MS = 10_000;

/**
 * React.lazy that reloads the page once when a chunk fails to load.
 * After a deploy, tabs opened on the old build request chunk hashes that no longer
 * exist; a reload picks up the new manifest. The timestamp guard prevents loops.
 */
export default function lazyWithReload(factory) {
  return lazy(() =>
    factory().catch((error) => {
      let lastReload = 0;
      try {
        lastReload = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
      } catch {}

      if (Date.now() - lastReload < RELOAD_GUARD_MS) throw error;

      try {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      } catch {}
      window.location.reload();

      // Keep the Suspense fallback visible until the reload happens.
      return new Promise(() => {});
    })
  );
}
